/**
 * URL Stripe redirects to after SetupIntent authentication (3DS / redirects).
 * Must be absolute HTTPS in production.
 */
function getFrontendBaseUrl() {
  return (
    process.env.REACT_APP_BASE_URL ||
    (typeof window !== 'undefined' ? window.location.origin : 'https://retechsys.ai')
  ).replace(/\/$/, '');
}

export function getPaymentSetupReturnUrl() {
  if (typeof window !== 'undefined' && window.__RETECHSYS_RUNTIME_CONFIG__?.paymentSetupReturnUrl) {
    return window.__RETECHSYS_RUNTIME_CONFIG__.paymentSetupReturnUrl;
  }
  return `${getFrontendBaseUrl()}/provider/payment-setup`;
}

export function getBillingReturnUrl() {
  if (typeof window !== 'undefined' && window.__RETECHSYS_RUNTIME_CONFIG__?.billingReturnUrl) {
    return window.__RETECHSYS_RUNTIME_CONFIG__.billingReturnUrl;
  }
  return `${getFrontendBaseUrl()}/provider/billing`;
}
